import "core-js/modules/es.array.reduce.js";
import { defineComponent, onUnmounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
export default defineComponent({
  name: 'ImageAccordion',
  props: {
    list: {
      type: Array,
      required: true
    },
    gap: {
      type: Number,
      default: 40
    },
    delay: {
      type: Number,
      default: 200
    }
  },
  setup: function (props) {
    var router = useRouter();
    var reactiveList = reactive(props.list);
    var onClickSlide = function (item) {
      if (item.link) {
        if (item.link.indexOf('http') === 0) {
          window.location.href = item.link;
        } else {
          router.push(item.link);
        }
      }
    };
    var onMouseEnter = function (item) {
      addTimer(item);
    };
    var onMouseLeave = function (item) {
      clearTimeout(item.timer);
    };
    var addTimer = function (item) {
      removeAllTimeout();
      item.timer = window.setTimeout(function () {
        reactiveList.forEach(function (i) {
          i.active = i.id === item.id;
        });
      }, props.delay);
    };
    var initialActive = reactiveList.reduce(function (acc, item) {
      return acc || item.active;
    }, false);
    if (!initialActive) {
      // 如果没有设置初始的active，默认设置为第一个slide
      reactiveList[0].active = true;
    }
    onUnmounted(function () {
      removeAllTimeout();
    });
    var removeAllTimeout = function () {
      reactiveList.forEach(function (i) {
        clearTimeout(i.timer);
      });
    };
    return {
      onClickSlide: onClickSlide,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      reactiveList: reactiveList
    };
  }
});